<script>
import { h } from 'vue';
import { avatarUrlForStyle, dimensionsForStyle } from '~/utils/avatar';

// Warning: This is a non-reactive component intended for usage in report tables
// If you need the avatar to change when userId or avatarStyle change, then
// use HubApp instead
export default {
  name: 'ReportTableAvatarPlain',
  props: {
    userId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      default: undefined,
      required: false, // this or :userId
    },
    avatarStyle: {
      type: String,
      default: 'speck',
    },
  },
  render() {
    const avatarStyle = this.avatarStyle;
    const dimensions = dimensionsForStyle(avatarStyle);
    let avatarUrl = this.url;

    if (avatarUrl === undefined) {
      const avatarData = this.$store.getters.allAvatars.get(this.userId);

      avatarUrl = avatarUrlForStyle(avatarData, avatarStyle);
    } else {
      avatarUrl ??= avatarUrlForStyle(null, avatarStyle);
    }
    const props = {
      class: `avatar avatar-${avatarStyle}`,
      src: avatarUrl,
      height: dimensions,
      width: dimensions,
    };

    return h('img', props);
  },
};
</script>
